import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedActivities } from '../../../../interfaces/activities/paginatedStore.type';

const tryToFetchActivities = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedActivities>> => {
    const url = filters
        ? `${USERS_API_URL}/hotel-world-user-invites/chat-documents?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/hotel-world-user-invites/chat-documents?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedActivities>(url, data);
};

const tryToFetchAllActivities = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/activities/all`);
};

const tryToFetchSingleActivity = (id: string): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/activities/${id}`);
};

export const ActivitiesService = {
    tryToFetchActivities,
    tryToFetchAllActivities,
    tryToFetchSingleActivity
};